import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { GoogleBadge } from "@/components/landing/GoogleBadge";

const TESTIMONIALS = [
  {
    quote: "Great service from start to finish.",
    name: "Jignesh Chaudhary",
    location: "New Brunswick",
    role: "Google Review",
  },
  {
    quote: "Can't say enough about the professionalism and quality of the work.",
    name: "Radical Edge",
    location: "New Brunswick",
    role: "Google Review",
  },
  {
    quote: "Excellent installation and customer service! Highly recommend this company.",
    name: "Verified Customer",
    location: "New Brunswick",
    role: "Google Review",
  },
  {
    quote: "Very satisfied with the security system installation. The team was knowledgeable and efficient.",
    name: "Verified Customer",
    location: "New Brunswick",
    role: "Google Review",
  },
];

const TestimonialCard = ({ t, testid, mobile = false }) => (
  <blockquote
    data-testid={testid}
    className={`bg-white border border-zinc-200 rounded-md p-6 md:p-8 flex flex-col transition-shadow duration-300 hover:shadow-[0_8px_30px_rgba(212,175,55,0.15)] ${
      mobile ? "w-[78vw] max-w-[320px] shrink-0" : ""
    }`}
  >
    <Quote className="w-8 h-8 text-[#D4AF37]/30 mb-4" />
    <div className="flex gap-1 mb-4" aria-label="5 out of 5 stars">
      {[...Array(5)].map((_, s) => (
        <Star key={s} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />
      ))}
    </div>
    <p className="text-sm sm:text-base leading-relaxed text-zinc-600 flex-1">"{t.quote}"</p>
    <footer className="mt-6 pt-6 border-t border-zinc-100">
      <p className="font-bold text-zinc-900 tracking-tight">{t.name}</p>
      <p className="text-sm text-zinc-500">
        {t.role} · {t.location}
      </p>
    </footer>
  </blockquote>
);

export const Testimonials = () => {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 lg:py-32 bg-[#F5F5F4] overflow-x-clip">
      <div className="container-x">
        <motion.div
          initial={{ x: -24 }}
          whileInView={{ x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
        <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-brand-primary mb-4">
          Reviews
        </p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter leading-none text-zinc-900 max-w-xl">
          What our customers say
        </h2>
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="origin-left mt-5 mb-14 h-1 w-20 rounded-full bg-gradient-to-r from-[#8C6D1F] via-[#D4AF37] to-[#E9C767]"
        />
        </motion.div>

        <div className="flex flex-wrap items-center gap-4 mb-10">
          <GoogleBadge />
          <a
            href="https://share.google/aqcRwZ7WPhcXb98sq"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-reviews-link"
            className="text-sm font-semibold text-brand-primary underline underline-offset-4 decoration-[#D4AF37]/50 hover:text-zinc-900 transition-colors"
          >
            See all our reviews on Google
          </a>
        </div>

        <div className="md:hidden overflow-hidden" data-testid="testimonials-marquee">
          <div className="marquee-track flex gap-4 w-max">
            {[...TESTIMONIALS, ...TESTIMONIALS].map((t, i) => (
              <TestimonialCard key={`m-${i}`} t={t} testid={`testimonial-card-m-${i}`} mobile />
            ))}
          </div>
        </div>

        <motion.div
          initial={{ x: 24 }}
          whileInView={{ x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="hidden md:grid md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {TESTIMONIALS.map((t, i) => (
            <TestimonialCard key={`d-${i}`} t={t} testid={`testimonial-card-${i}`} />
          ))}
        </motion.div>

      </div>
    </section>
  );
};
